import { actions } from '@app/action/account';
import Transform from '@app/transformers';
import { ACTIVE_STATUSES } from '@constant/subscriptions';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.GET_ACCOUNT:
    case actions.ACCOUNT_UPDATE_SUCCESS:
      return {
        ...state,
        ...Transform.account(action.details),
      };

    case actions.GET_SUBSCRIPTION:
      return {
        ...state,
        active_subscription:
          action.details.active ||
          ACTIVE_STATUSES.includes(action.details.status),
        subscription: {
          ...state.subscription,
          ...action.details,
        },
      };

    case actions.CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscription: {
          ...state.subscription,
          cancel_at_period_end: true,
        },
      };

    case actions.REACTIVATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscription: {
          ...state.subscription,
          cancel_at_period_end: false,
        },
      };

    case actions.GET_LAST_ORDER:
      return {
        ...state,
        lastOrder: action.details,
      };

    case actions.GET_CHECKOUT_DETAILS: {
      return {
        ...state,
        checkout: action.details,
      };
    }

    case actions.PAYMENT_SUCCESS:
      return {
        ...state,
        payment: action.details,
      };

    case actions.UPDATE_ACCOUNT_MEMBERSHIP_USER_EMAIL:
      if (state.memberships.length === 0) {
        return state;
      }

      return {
        ...state,
        memberships: [
          {
            ...state.memberships[0],
            user: {
              ...state.memberships[0].user,
              email: action.email,
            },
          },
        ],
      };
  }

  return state;
}
